import axios from 'axios'
import Cookies from 'js-cookie';


const instance = axios.create({
    // baseURL: window.location.host.includes('staging') ? 'https://staging-user.assesshub.com/v3' : window.location.host.includes('user') ? 'https://api-user.assesshub.com/v3' : 'http://localhost:3006/v3'
    baseURL: window.location.host.includes('localhost') ? 'http://localhost:3636/v3' : 'https://api-user.evalcore.pyther.com/v3'
});
instance.interceptors.request.use(
    request => {
        request.headers.common['Authorization'] = `Bearer ${Cookies.get('token')}`
        return request;
    },
    error => {
        return Promise.reject(error);
    }
)

// Add a response interceptor
instance.interceptors.response.use(function (response) {
// Any status code that lie within the range of 2xx cause this function to trigger
// Do something with response data
return response;
}, function (error) {
    if (error.response.status === 401) {
        Cookies.set("sessionTime",'2')
        Cookies.set('login', '', { path: '/' });
        Cookies.set('token', '', { path: '/' });
        window.location.href = "/v2/user/login";
    }
// Any status codes that falls outside the range of 2xx cause this function to trigger
// Do something with response error
return Promise.reject(error);
});

export default instance